import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderEdit"><Path d="M4.24219 10.0068C5.48483 10.0068 6.49219 11.0142 6.49219 12.2568V18.8105L4.24219 21.0605L1.99219 18.8105V12.2568C1.99219 11.0143 2.99966 10.007 4.24219 10.0068Z" fill="currentColor"/><Path d="M12.4004 6H21.999V20H7.42383L7.99219 19.4316V12.2568C7.99219 10.2506 6.41675 8.61235 4.43555 8.51172L4.24219 8.50684C3.40107 8.50693 2.62467 8.78416 1.99902 9.25195V3H10.4004L12.4004 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderEdit;
